import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import pairing from './pairing'
import payment from './payment'
import campaign from './campaign/index'
import campaignTimeline from './campaign/timeline'
import post from './post'
import client from './client'
import influencer from './influencer'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    pairing,
    payment,
    campaign,
    campaignTimeline,
    post,
    client,
    influencer
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js